import React from 'react';
import cl from './Features.module.css';
import {
    IconRocket, IconTeacher, IconTarget, IconDashboard,
    IconRobot, IconRefresh,
} from '../../components/icons';
import useReveal from '../../hooks/useReveal';

// 6 ключевых преимуществ для владельца детского центра.
const features = [
    {
        Icon: IconRocket,
        accent: '#3b82f6', soft: 'rgba(59, 130, 246, 0.1)',
        title: 'Готовая программа на 3 года',
        text: '20+ курсов и 700+ уроков уже разработаны. Не нужно искать преподавателей, писать программы и собирать материалы.',
    },
    {
        Icon: IconTeacher,
        accent: '#a855f7', soft: 'rgba(168, 85, 247, 0.1)',
        title: 'Преподаватели не обязательны',
        text: 'Уроки записаны автором школы. Ваш сотрудник нужен только чтобы помогать детям и следить за дисциплиной.',
    },
    {
        Icon: IconTarget,
        accent: '#10b981', soft: 'rgba(16, 185, 129, 0.1)',
        title: '30 000+ интерактивных задач',
        text: 'Задачи проверяются автоматически. Ребёнок не зависит от преподавателя — учится в своём темпе и сразу видит результат.',
    },
    {
        Icon: IconDashboard,
        accent: '#f59e0b', soft: 'rgba(245, 158, 11, 0.1)',
        title: 'Свой кабинет управления',
        text: 'Список учеников, журнал посещений, оплаты, отчёты по группам — всё в одной админ-панели для вашего центра.',
    },
    {
        Icon: IconRobot,
        accent: '#ef4444', soft: 'rgba(239, 68, 68, 0.1)',
        title: 'Робототехника и Minecraft',
        text: 'Дети любят то, что мы преподаём: Minecraft-серверы, Arduino, 3D-моделирование, программирование. Это сразу привлекает учеников.',
    },
    {
        Icon: IconRefresh,
        accent: '#06b6d4', soft: 'rgba(6, 182, 212, 0.1)',
        title: 'Обновления без доплат',
        text: 'Новые курсы, уроки и задачи добавляются автоматически. Платформа развивается — вы получаете это бесплатно.',
    },
];

export default function Features() {
    const revealRef = useReveal();
    return (
        <section className={cl.features} ref={revealRef}>
            <div className={cl.inner}>
                <div className={cl.head}>
                    <span className={cl.eyebrow} data-reveal="down">Что вы получаете</span>
                    <h2 className={cl.title} data-reveal="up" style={{ '--reveal-delay': '100ms' }}>
                        Не курс — готовая IT-вертикаль для вашего центра
                    </h2>
                    <p className={cl.subtitle} data-reveal="up" style={{ '--reveal-delay': '180ms' }}>
                        Открывайте набор учеников за неделю. Программа,
                        преподаватели и инфраструктура — уже на нашей стороне.
                    </p>
                </div>

                <div className={cl.grid} data-reveal-stagger>
                    {features.map((f, idx) => {
                        const Icon = f.Icon;
                        // Чередуем эффекты: чётные — pop, нечётные — slide
                        const effect = idx % 2 === 0 ? 'pop' : (idx % 3 === 0 ? 'left' : 'right');
                        return (
                            <div key={f.title} className={cl.card}
                                data-reveal={effect}
                                style={{ '--accent': f.accent, '--accent-soft': f.soft }}>
                                <div className={cl.icon}><Icon width={26} height={26}/></div>
                                <h3 className={cl.cardTitle}>{f.title}</h3>
                                <p className={cl.cardText}>{f.text}</p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
